import styled from 'styled-components';

export const ContentContainer = styled.div`
  display: flex;
`;

export const Image = styled.img`
  height: 200px;
  margin-right: 32px;
`;

export const NameContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const Title = styled.h1`
  font-size: 24px;
  margin: 0 0 16px;
`;

export const DetailGroup = styled.span`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-bottom: 24px;
`;

export const SubTitle = styled.h4`
  color: ${({ theme }) => theme.colors.grey5};
  font-size: 13px;
  font-weight: bold;
  text-transform: uppercase;
  margin: 0;
`;
